import { createElement } from 'react';

import { Controller } from '@hotwired/stimulus';
import { createRoot } from 'react-dom/client';

import AuthApp from '../components/auth/AuthApp';

export default class extends Controller {
  static values = {
    pathPrefix: String,
    phoneConfirmation: Boolean,
    phoneDisplay: String,
    phoneMergeConfirmation: Object,
    phoneResendCooldown: Number,
    phoneSkippable: Boolean,
    privacyUrl: String,
    signupInvitationEmail: String,
    signupInvitationMode: String,
    signupInvitationRequired: Boolean,
    successUrl: String,
    termsUrl: String,
  };

  connect() {
    this.root = createRoot(this.element);
    this.root.render(
      createElement(AuthApp, {
        pathPrefix: this.pathPrefixValue,
        phoneConfirmation: this.phoneConfirmationValue,
        phoneDisplay: this.phoneDisplayValue,
        phoneMergeConfirmation: this.hasPhoneMergeConfirmationValue ? this.phoneMergeConfirmationValue : null,
        phoneResendCooldown: this.phoneResendCooldownValue,
        phoneSkippable: this.phoneSkippableValue,
        privacyUrl: this.privacyUrlValue,
        signupInvitationEmail: this.signupInvitationEmailValue,
        signupInvitationMode: this.signupInvitationModeValue,
        signupInvitationRequired: this.signupInvitationRequiredValue,
        successUrl: this.successUrlValue,
        termsUrl: this.termsUrlValue,
      }),
    );
  }

  disconnect() {
    this.root?.unmount();
    this.root = null;
  }
}
